// @ts-strict-ignore
export class ObjInfo {
  public objContent: string = '';
  public mtlContent: string = '';
  public textures: ObjTextureInfo[] = [];
  public verticesCount: number;
}

export class ObjTextureInfo {
  public name: string;
  public content: any[];
  public url: string;
  public articleParameters: string;
}
